import React from 'react';
import { formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import ItemVariantField from './ItemVariantField';

const FORM_NAME = 'modal_item_variants';

class ItemVariantFieldArray extends React.Component {
  render() {
    const {
      fields,
      ingredientSubscriptionDetail,
      isSalesTypePrice,
    } = this.props;
    return (
      <div className="row">
        <div className="form-group col-sm-12 mb-0px">
          <a className="btn btn-primary btn-block" onClick={this._onClickAdd}>
            Add Variant
          </a>
        </div>
        {fields.map((member, index) => {
          return (
            <ItemVariantField
              key={index}
              index={index}
              member={member}
              isSalesTypePrice={isSalesTypePrice}
              isRecipe={
                ingredientSubscriptionDetail.is_active &&
                fields.get(index).is_recipe
              }
              showDelete={fields.length > 1}
              onDelete={() => this._onDelete(index)}
              onChangePriceVariant={this._onChangePriceVariant}
            />
          );
        })}
      </div>
    );
  }

  _onChangePriceVariant = (event, index) => {
    const { dispatch, itemOutlets } = this.props;
    // update variant to custom outlets
    // should be immutable in order to update data
    const newItemOutlet = itemOutlets.map(itemOutlet => {
      return {
        ...itemOutlet,
        item_variant_custom_outlet_prices: itemOutlet.item_variant_custom_outlet_prices.map(
          (iv, idx) => {
            if (idx === index) {
              return {
                ...iv,
                price: event.target.value,
              };
            }
            return {
              ...iv,
            };
          }
        ),
      };
    });
    dispatch(change(FORM_NAME, 'item_outlets', newItemOutlet));
  };

  _onDelete = index => {
    const { fields, itemOutlets, dispatch } = this.props;
    // remove variant custom outlets
    // should be immutable in order to remove data
    const newItemOutlets = itemOutlets.map(itemOutlet => {
      return {
        ...itemOutlet,
        item_variant_custom_outlet_prices: itemOutlet.item_variant_custom_outlet_prices.filter(
          (_, idx) => {
            return idx !== index;
          }
        ),
      };
    });
    dispatch(change(FORM_NAME, 'item_outlets', newItemOutlets));
    fields.remove(index);
  };

  _onClickAdd = () => {
    const {
      fields,
      salesType,
      isSalesTypePrice,
      itemOutlets,
      dispatch,
    } = this.props;
    const initialValue = {
      temp_business_level_item_variant_id: fields.length + 1,
      name: '',
      price: null,
      sku: '',
    };
    if (isSalesTypePrice) {
      const salesTypeItems = [];
      salesType
        .filter(e => e.selected)
        .map(st => {
          salesTypeItems.push({
            business_level_sales_type_id: st.id,
          });
        });
      initialValue.sales_type_item_variants = salesTypeItems;
    }
    // add variant to custom outlets
    // should be immutable in order to append data
    const newItemOutlet = itemOutlets.map(itemOutlet => {
      return {
        ...itemOutlet,
        item_variant_custom_outlet_prices: itemOutlet.item_variant_custom_outlet_prices.concat(
          {
            ...initialValue,
            temp_business_level_item_variant_id:
              initialValue.temp_business_level_item_variant_id,
          }
        ),
      };
    });
    dispatch(change(FORM_NAME, 'item_outlets', newItemOutlet));
    fields.push(initialValue);
  };
}

const selector = formValueSelector(FORM_NAME);

function mapStateToProps(state) {
  return {
    itemOutlets: selector(state, 'item_outlets'),
  };
}

export default connect(mapStateToProps)(ItemVariantFieldArray);
